import { render, staticRenderFns } from "./addUserMsg.vue?vue&type=template&id=7bde2f1c&scoped=true&"
import script from "./addUserMsg.vue?vue&type=script&lang=js&"
export * from "./addUserMsg.vue?vue&type=script&lang=js&"
import style0 from "./addUserMsg.vue?vue&type=style&index=0&id=7bde2f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bde2f1c",
  null
  
)

export default component.exports